import React from 'react'
import NextDayMatches from './matches/NextDayMatches'
import NextDayStayTuned from './stayTuned/NextDayStayTuned'

const NextDayPrediction = (prop) => {

  return (
    <div>
        <NextDayStayTuned />
       {prop.matchData.map((items, index) =>
             <NextDayMatches key={index} match={items}/>
      )}
    </div>
  )
}

export default NextDayPrediction